import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';

import {
    trigger,
    state,
    style,
    animate,
    transition
} from '@angular/animations';
import { DatabaseService } from 'app/database.service';
import { SwiperComponent } from 'ngx-swiper-wrapper';


declare var jQuery: any;


@Component({
    selector: 'home-page',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('fadeAndZoom', [
            state('inactive', style({
                opacity: 0,
                transform: 'scale(0.8)'
            })),
            state('active', style({
                opacity: 1,
                transform: 'scale(1)'
            })),
            transition('inactive => active', animate('100ms ease-in')),
            transition('active => inactive', animate('100ms ease-out'))
        ])
    ]
})




export class HomeComponent implements OnInit {
    @ViewChild('swiper') swiper: SwiperComponent;
    swiperConfig: Object = {
        // pagination: '.swiper-pagination',
        // paginationClickable: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        spaceBetween: 30,
      };

    constructor(
        private database: DatabaseService
    ) { }


    ngOnInit(){
        
    }


}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts